module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"19\" height=\"18\" viewBox=\"0 0 19 18\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M18.2 0L1 17.2M1 0l17.2 17.2\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/CloseButton/closeIcon.svg
// module id = 876
// module chunks = 114276838955818